(function() {
  window.filterMaterials = function(tag, btn) {
    document.querySelectorAll('.filter-bar .chip').forEach(function(c) { c.classList.remove('active'); });
    if (btn) btn.classList.add('active');
    document.querySelectorAll('.mat-card').forEach(function(card) {
      if (tag === 'all') {
        card.classList.remove('hidden');
      } else {
        var tags = (card.dataset.tags || '').split(/\s+/).filter(Boolean);
        card.classList.toggle('hidden', tags.indexOf(tag) === -1);
      }
    });
  };
})();
